import { render, staticRenderFns } from "./FormPerson.vue?vue&type=template&id=31080d98&"
import script from "./FormPerson.vue?vue&type=script&lang=js&"
export * from "./FormPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormPerson.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports